import { Component, input } from '@angular/core'

import { BndButton, BndLoading, BndModal } from '@bonduelle-it/storybook'
import { TranslatePipe } from '@ngx-translate/core'
@Component({
  selector: 'app-new-version-popup',
  templateUrl: './new-version-popup.component.html',
  imports: [TranslatePipe, BndLoading, BndButton, BndModal],
})
export class NewVersionPopupComponent {
  public readonly open = input(false)
  public isUpdateInProgress: boolean = false

  reload() {
    this.isUpdateInProgress = true
    window.location.reload()
  }
}
